var map = {
	"./adobe-xd-icon.png": 9583,
	"./aiBanking.png": 651,
	"./airbnbLogo.png": 1476,
	"./alexandre.jpg": 2311,
	"./codeInLogo.webp": 4796,
	"./contactMail.webp": 436,
	"./contactMailDark.svg": 9812,
	"./developerActivity.svg": 9504,
	"./ebacLogo.png": 7959,
	"./facebookLogo.png": 6282,
	"./gamifiedTest.png": 5941,
	"./googleAssistant.svg": 9650,
	"./googleAssistantLogo.webp": 4217,
	"./harvardLogo.png": 7594,
	"./jsFramework.svg": 4406,
	"./manOnTable.svg": 3350,
	"./nextuLogo.webp": 3480,
	"./programmer.svg": 2075,
	"./pwa.webp": 7571,
	"./pwaLogo.webp": 4300,
	"./quoraLogo.png": 2956,
	"./saayaHealthLogo.webp": 3267,
	"./senaiLogo.png": 1994,
	"./skill.svg": 1262,
	"./stanfordLogo.png": 6893,
	"./sumuppix.png": 2810,
	"./talksCardBack.svg": 7175,
	"./yasmin.jpg": 7228,
	"./your-face-image.png": 7046
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;